import React, { useEffect, useState } from 'react';
import "./ConferenceRoom.css";
import { useNavigate,useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import useAuth from '../../../customHooks/useAuth';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import { HOTEL_TIMEZONE, toHotelISO } from "../../../common/hotelTime";

export default function ConferenceRoom() {

    // Get today's and tomorrow's date
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const location = useLocation();
    const navigate = useNavigate();

    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem('user_id');
    // console.log("Booked Rooms Conference : ",bookedRooms);

    const bookingId = location.state?.bookingId || "";
    const hotelId = location.state?.hotelId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const booking_code = location.state?.booking_code || "";


    // Error Handling
    const [errors, setErrors] = useState({});

    // const [people,setPeople] = useState(1);
    // const [hr,setHr] = useState(1);

    const [formData,setFormData] = useState({
        people : "",
        comment : "",
        time : "",
        serviceDate : "",
        hours : "",
        minutes : "",
    });


    // Loader
    const [isLoading,setIsLoading] = useState(false);
 

    // Refresh Handle 
    useAuth();

    // Check id's
    useEffect(()=>{
        const checkId = ()=>{
            if(hotelId==="" || bookingId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[hotelId,bookingId,navigate]);

 
    // Format Date
    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            timeZone: HOTEL_TIMEZONE,
        day: 'numeric',
        month: 'short',
        });
    };

    // Function to handle date selection
    const handleDateSelection = (selectedDate) => {
        setFormData((prevState) => ({
        ...prevState,
        serviceDate: selectedDate,
        }));
        validateField("serviceDate",selectedDate);
    };

    // Handle Change Function
    const handleChange = (e)=>{
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        validateField(name,value);
    };


    // Validate Field
    const validateField = (field, value) => {
        const newErrors = { ...errors };
        // const numberRegex = /^[1-9][0-9]*$/; // Regex to ensure only positive integers greater than 0
     

        switch(field){
            case "serviceDate":
                if(!value.trim()){
                    newErrors.serviceDate = "Date selection is required";
                }else{
                    newErrors.serviceDate = "";
                }
            break;

            case "time":
                if(!value.trim()){
                    newErrors.time = "Time selection is required";
                }else{
                    newErrors.time = "";
                }
            break;

            case "hours":
                if (!value.trim()) {
                    newErrors.hours = "Please Enter Hour";
                } 
                else if (!/^\d+$/.test(value)) {
                    newErrors.hours = "Hours must number greater than or equal to 0";
                } 
                else if (parseInt(value) < 0) {
                    newErrors.hours = "Hours must number greater than or equal to 0";
                }
                else{
                    newErrors.hours = "";
                }
            break;

            case "minutes":
                if (!value.trim()) {
                    newErrors.minutes = "Please Enter minutes or write 0";
                } else if (!/^\d+$/.test(value)) {
                    newErrors.minutes = "Minutes must greater than or equal to 0";
                }
                else if (parseInt(value) < 0 ) {
                    newErrors.minutes = "Minutes must greater than or equal to 0";
                }
                else if(parseInt(value)>60){
                    newErrors.minutes  = "Minutes must in range of 60";
                } 
                else{
                    newErrors.minutes = "";
                }
            break;
            
            case "people" :
                if(!value.trim()){
                    newErrors.people = "Please Enter Number of People";
                }
                else{
                    newErrors.people = "";
                }
            break;

            default:
                break;
        }
        setErrors(newErrors);
    };

    // Validate Form
    const validateForm = ()=>{
        const validationErrors = {};
        const numberRegex = /^[1-9][0-9]*$/; // Regex to ensure only positive integers greater than 0
      
        if(!formData.serviceDate.trim()){
            validationErrors.serviceDate = "Date Selection Required";
        }

        // Hours
        if (!formData.hours.trim()) {
            validationErrors.hours = "Please Enter Hour";
        }
        if(!/^\d+$/.test(formData.hours)){
            validationErrors.hours = "Hour must an integer";
        }
        if (parseInt(formData.hours) < 0) {
            validationErrors.hours = "Hour must greater than or equal to 0";
        }

        // Minutes
        if (!formData.minutes.trim()) {
            validationErrors.minutes = "Please Enter minutes";
        }
        if(!/^\d+$/.test(formData.minutes)){
            validationErrors.minutes = "minutes must number greater than or equal to 0";
        }
        if (parseInt(formData.minutes) < 0 ) {
            validationErrors.minutes = "minutes must number greater than or equal to 0";
        }
        if (parseInt(formData.minutes) >60) {
            validationErrors.minutes = "minutes must in range of 60";
        }
 
        if(!formData.time.trim()){
            validationErrors.time = "Time Selection Required";
        }

        if(!formData.people.trim()){
            validationErrors.people = "Please Enter the People";
        }
        if (!numberRegex.test(formData.people)) {
            validationErrors.people = "Number of people must be a positive integer greater than 0 and not start with 0 and No Spaces is Allowed";
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    }

    // Handle Submit
    const handleSubmit = async()=>{
        try{
            if(!validateForm()){
                // console.log("Please Validate form")
                return;
            }
            // console.log("FormData : ",formData);
            setIsLoading(true);
            // Combine selected date and time into ISO 8601 format
            // Get current year
            const currentYear = new Date().getFullYear();
            // Combine selected date and time into ISO 8601 format
            const selectedDate = new Date(`${formData.serviceDate} ${currentYear}`); // Add current year
            const [hours, minutes] = formData.time.split(':');

            // Set the time to the selected date
            selectedDate.setHours(hours);
            selectedDate.setMinutes(minutes);
            selectedDate.setSeconds(0);


            // Format function without converting to UTC
            // Get the formatted date-time with specified offset
            const isoDateTimeWithInd = toHotelISO(selectedDate);
            // console.log("Date with Offset: ", isoDateTimeWithInd);



            // Handle People
            const peopleData = formData.people.trim();
            const peopleNum =  parseInt(peopleData, 10);
            // console.log("People",peopleNum)


            // Convert to ISO format
            // const isoDateTime = selectedDate.toISOString();
            // console.log("Date : ",isoDateTime);


            // Hours and Minutes
            const  confHour = formData.hours.trim();
            const  confMinute = formData.minutes.trim();
            const combinedTime = `${confHour}.${confMinute}`;
            // console.log("Combined Time: ", combinedTime);
       



            const currentUser = await getCurrentUser();
 
            function findMatchedRooms(bookedRooms, usersData) {
                const contact = usersData.contact;
                const matchedRooms = bookedRooms.filter((room)=>{
                    // Check if guests are null or an empty array, and skip the room if true
                    if (!room.guests || room.guests.length === 0) {
                        return false; // Skip this room
                    }
                    const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                    if(matchedGuest) {
                        return true; //
                    }
                    else{
                        return false;
                    }
                });
                return matchedRooms;
            }        

            const usersData = currentUser;  
            const matchedRooms = findMatchedRooms(bookedRooms, usersData);

            if(matchedRooms.length<=0){
                // console.log("Booking is not Present ");
                return;
            }
            // console.log("MAtched Rooms : " + matchedRooms[0].id);

   
            try{
                const passData = {
                    additional_comments: formData.comment.trim(),
                    duration_hours: combinedTime,
                    number_of_people: peopleNum,
                    preferred_time: isoDateTimeWithInd
                };
                const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/conference-room-request/`,passData);

                // console.log("Data To Be submitted : ",response.data);
                toast.success("Conference Room Request Created Successfully");
                navigate("/bookings",{state : {activeRequests : "requests"}});

            }catch(error){
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.log(error);
            }

        }catch(error){
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }
   

  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className="conferenceRoom">
            <Header title="Conference Room Request" 
                hotelName = {hotelName}
                hotelAddress = {hotelAddress}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                status = {status}
                activeTab = {activeTab}
                hotelId = {hotelId}
                bookingId = {bookingId}
                movetoHotel = "movetoHotel"
                booking_code = {booking_code}
            />
            <div className="conference-data">

                {/* How many people are going to be there? */}
                <div className="conference-fields">
                    <div className="conference-name">
                        <h4>How many people are going to be there?</h4>
                    </div>
                    <div className="conference-inp">
                        <input type="text" maxLength={4} name="people" onChange={handleChange}  />
                    </div>
                    {errors.people && <span className="error-message">{errors.people}</span>}

                    {/* <div className="conference-inpGuests">
                        <div className='qtyButton' onClick={()=>decreaseQty("people")} ><span>-</span></div>
                        <div className='qty'>{people}</div>
                        <div className='qtyButton' onClick={()=>increaseQty("people")} ><span>+</span></div>
                    </div> */}
                </div>

                {/* Minutes and Hours For Conference Room */}
                <div className="conference-fields">
                    <div className="conference-name">
                        <h4>For How Much Time You Want Conference Room ?</h4>
                    </div>
                    <div className="conference-inps">
                        {/* <input type="time" name="timeData" onChange={handleChange} /> */}
                    
                        <input type="text" placeholder="Hours" name="hours" onChange={handleChange} autoComplete='off' maxLength={2} />
                    
                        <input type="text" placeholder='Minutes' name="minutes" onChange={handleChange} autoComplete='off' maxLength={2}  />
                    
                    </div>
                    {errors.hours && <span className="error-message">{errors.hours}</span>}
                    {errors.minutes && <span className="error-message">{errors.minutes}</span>}
                </div>

                {/* Date of Service */}
                <div className='conference-fields'>
                    <div className='conference-name'>
                        <h4>Date of the service</h4>
                    </div>
                    <div className='date-selection'>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(today) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(today))}
                        >
                        {formatDate(today)}  
                        </div>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(tomorrow) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(tomorrow))}
                        >
                        {formatDate(tomorrow)}  
                        </div>
                    </div>
                    {errors.serviceDate && <span className="error-message">{errors.serviceDate}</span>}
                </div>

                {/* When do you want the conference room? */}
                <div className="conference-fields">
                    <div className="conference-name">
                        <h4>Preffered Time</h4>
                    </div>
                    <div className='conference-inp'>
                        <input type="time" name='time' value={formData.time} onChange={handleChange}  />
                    </div>
                    {errors.time && <span className="error-message">{errors.time}</span>}
                </div>

    

                {/* Comments */}
                <div className="conference-fields">
                    <div className="conference-name">
                        <h4>Comments</h4>
                    </div>
                    <div className='conference-inp'>
                        <textarea name="comment" rows='4' cols="10" value={formData.comment} onChange={handleChange} ></textarea>
                    </div>
                    {errors.comment && <span className="error-message">{errors.comment}</span>}
                </div>

                {/* Button */}
                <div className="conference-btn">
                    <button onClick={handleSubmit} disabled={formData.serviceDate==="" || formData.time==="" || formData.timeData===""} >Request Conference Room</button>
                </div>

            </div>
        </div>
    </>
  )
}